import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { tmsConfig } from '../../../../core/tms-config';
// import {ModalService} from 'sce-ui-lib';
import {
  AlertService,
  ModalService,
  ResourceService,
  UserService,
} from 'sce-core';
import { DefaultMapService } from '../../maps/service/default-map.service';
import { Paginator } from 'primeng-lts/paginator';
import { DialogService, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { ParamsService } from '../../params.service';
// import {Paginator} from 'primeng/primeng';
import { catchError, map } from 'rxjs/operators';
import { generateGid } from '../../../../shared/services/business-unit-gid.util';

@Component({
  selector: 'lfwms-dashboard-truck-number-detail',
  templateUrl: './truck-number-detail.component.html',
  styleUrls: [
    '../../shipment/shipment-home/dispatched-order/dispatched-order.component.css',
    './truck-number-detail.component.css',
  ],
  providers: [DefaultMapService],
})
export class TruckNumberDetailComponent implements OnInit {
  public searchService: any;
  public cancelHandler: any;
  public confirmHandler: any;
  public confirmHandler2: any;
  public confirmHandler3: Function;
  public columnDef: any[] = [];
  // public listPerPage: any[] = [];
  public servprovGid: any;
  public equipmentGroupGid: any;
  public selectedRow: any;
  showSearch: boolean = false;
  showSearchDriver: boolean = false;
  searchCondition: any = {};
  pageInfo: any = { number: 0, size: 5, total: 0, content: [] };
  @ViewChild('paginator')
  paginator: Paginator;
  countryCode: any;
  Gid: any;
  isBookingLookup = false;
  lookupShipmentXid = '';

  constructor(
    public http$: HttpClient,
    public modalService: ModalService,
    public alertService: AlertService,
    public userService: UserService,
    public dialogService: DialogService,
    public ref: DynamicDialogRef,
    public paramsService: ParamsService,
    public resourceService: ResourceService,
    public mapService: DefaultMapService
  ) {}

  public ngOnInit() {
    this.showSearch = this.paramsService.showSearch;
    this.isBookingLookup = !!this.paramsService.onlyShow;
    this.lookupShipmentXid = this.paramsService.lookupShipmentXid || '';
    this.searchCondition.servprovGid = this.paramsService.servprovGid;
    this.searchCondition.equipmentGroupGid =
      this.paramsService.TruckEquipmentGroupGid;
    this.truckTypeFilterLabel = this.paramsService.requiredTruckTypeName || '';
    if (this.isBookingLookup) {
      this.pageInfo.size = 100;
    }
    this.queryUserInfo().subscribe(data => {
      this.countryCode = generateGid(
        data['userInfo']['userRestrictions'][0]['countryCode']
      );
      this.getBusinessUnitGid(
        data['userInfo']['userRestrictions'][0]['countryCode']
      );
    });

    if (!this.isBookingLookup) {
      this.mapService.initMapMarker('truck_number_map', '');
    }
    this.columnDef = this.getColumnDef();
  }

  truckTypeFilterLabel = '';

  clearTruckTypeFilter(): void {
    this.truckTypeFilterLabel = '';
    this.searchCondition.equipmentGroupGid = null;
    this.paramsService.TruckEquipmentGroupGid = null;
    this.paramsService.requiredTruckTypeName = null;
    this.pageInfo.number = 0;
    this.search();
  }

  public queryUserInfo() {
    return this.http$
      .post(
        '/htms/api/user/sce/getUserInfo',
        JSON.stringify({
          key: JSON.parse(localStorage.getItem('jwt_token')).token,
        })
      )
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }
  getBusinessUnitGid(value) {
    let params: HttpParams = new HttpParams();
    this.http$
      .get(tmsConfig.tms.getBusinessUnitGid + generateGid(value), {
        params: params,
      })
      .subscribe((res: any) => {
        this.Gid = res;
        this.searchCondition.businessUnitGid = this.Gid;
        this.search();
      });
  }
  getColumnDef() {
    const cols = [
      {
        elementId: this.resourceService.get('lbl_tms_truck_type'),
        propertyName: 'equipmentGroupName',
      },
      {
        elementId: this.resourceService.get('lbl_tms_truck_number'),
        propertyName: 'carNumber',
      },
      {
        elementId: this.resourceService.get('lbl_tms_driver_name'),
        propertyName: 'driverName',
      },
    ];
    if (!this.isBookingLookup) {
      cols.push({
        elementId: this.resourceService.get('lbl_tms_carrier_name'),
        propertyName: 'servprovName',
      });
    }
    cols.push({
      elementId: this.resourceService.get('lbl_tms_fleet_quota') || 'Fleet',
      propertyName: 'attribute1',
    });
    return cols;
  }

  search() {
    let params: HttpParams = new HttpParams();
    Object.keys(this.searchCondition).forEach(k => {
      if (this.searchCondition[k]) {
        params = params.set(k, this.searchCondition[k]);
      }
    });
    params = params
      .set('page', this.pageInfo.number || 0)
      .set('size', this.pageInfo.size || 10);

    this.http$
      .post(tmsConfig.tms.equipmentQueryUri, this.searchCondition, {
        params: params,
      })
      .toPromise()
      .then(data => {
        const selectedId = this.selectedRow?.id;
        this.pageInfo = data;
        // Keep selection across async/paginator refresh so Confirm still has a row.
        this.selectedRow = selectedId
          ? (this.pageInfo.content || []).find(
              (row: any) => row.id === selectedId
            ) || null
          : null;
        if (!this.isBookingLookup) {
          this.refreshMap();
        }
      });
  }

  private refreshMap() {
    const points = [];
    this.pageInfo.content.forEach((row: any) => {
      points.push([row.sightingLon, row.sightingLat]);
    });
    this.mapService.refreshMapMarker(points);
  }

  onConfirm() {
    if (!this.selectedRow) {
      return;
    }
    this.paramsService.truckNumDate = this.selectedRow;
    this.selectedRow.buttonType = 'confirm';
    if (this.paramsService.onlyShow || this.paramsService.onlyShow2) {
      this.ref.close(this.selectedRow);
    } else {
      this.ref.close(TruckNumberDetailComponent);
    }
  }

  onCancel() {
    this.ref.close(TruckNumberDetailComponent);
  }

  onPageChange($event: any) {
    this.pageInfo.number = this.paginator.getPage();
    this.pageInfo.size = this.paginator.rows;
    this.search();
  }

  onRowClick(e: any) {
    this.selectedRow = this.selectedRow === e.data ? null : e.data;
  }

  updateFilter() {
    setTimeout(() => {
      this.search();
    }, 200);
  }
}

